import { Link, Navigate } from "react-router-dom";
import classes from "./InquireSuccess.module.css";

const InquireSuccess = () => {
  return (
    <div className={classes.successContainer}>
      <p className={classes.successMessage}>我們會盡快與你聯絡，謝謝🥰</p>
      <Link to="/" className={classes.redirect}>
        返回首頁
      </Link>
    </div>
  );
};

export default InquireSuccess;
